import { AppState } from '../../../types';
import { LOADER_IDS, LoaderState } from './loader.types';

export const getLoaderState = (state: AppState): LoaderState => state.loader;

export const isLoading = (loaderId: LOADER_IDS) => (state: AppState): boolean => {
  return getLoaderState(state)[loaderId].isLoading;
};
